<template>
    <div class="wrap wrap--last">
        <SectionTitle text="Brand" class="title" />

        <ul class="brandList" v-show="$store.state.switchTab.brand">
            <li v-for="(item, index) in brandList" :key="'ranking' + index">
                <a :href="item[$store.state.hostName]">
                    <img :src="item.imageURL" alt="">
                </a>
            </li>
        </ul>

        <MoreLink to="/brands" text="ALL" />
    </div>
</template>

<script>
import SectionTitle from '@/components/SectionTitle.vue'
import MoreLink from '@/components/MoreLink.vue'

export default {
  name: 'Brand',

  components: {
    SectionTitle,
    MoreLink
  },

  computed: {
    brandList () {
      return this.$store.state.json.brand.slice(0, 60)
    }
  }
}
</script>

<style lang="scss" scoped>
.brandList {
    display: grid;
    grid-template-columns: repeat(10, 1fr);
    border-top: 1px solid #dddddd;
    border-left: 1px solid #dddddd;

    @media screen and (max-width: 722px) {
        grid-template-columns: repeat(4, 1fr);
    }

    @media screen and (min-width: 723px) and (max-width: 963px) {
        grid-template-columns: repeat(6, 1fr);
    }

    @media screen and (min-width: 964px) and (max-width: 1523px) {
        grid-template-columns: repeat(10, 1fr);
    }

    @media screen and (min-width: 1524px) and (max-width: 2286px) {
        grid-template-columns: repeat(10, 1fr);
    }

    @media screen and (min-width: 2287px) {
        grid-template-columns: repeat(10, 1fr);
    }

    >li {
        align-content: center;
        aspect-ratio: 1 / 1;
        padding: 10px;
        text-align: center;
        border-right: 1px solid #dddddd;
        border-bottom: 1px solid #dddddd;

        a {
            position: relative;
            display: block;

            &:hover {
                opacity: .5;
                transition: .2s;
            }
        }
    }

    img {
        width: 60%;
    }
}
</style>
